import {apiStore} from "@/stores/api";

export default {
    data() {
        return {
            pingInterval : 0
        };
    },

    computed: {
        isOnline() {
            return apiStore().isOnline;
        }
    },

    created() {
        clearInterval(this.pingInterval);
        apiStore().pingServer();
        this.pingInterval = setInterval(() => {
            apiStore().pingServer();
        }, 30000);
    },

    destroyed() {
        clearInterval(this.pingInterval);
    }
};